import { render, staticRenderFns } from "./AdminPermission.vue?vue&type=template&id=0810ca58&scoped=true"
import script from "./AdminPermission.vue?vue&type=script&lang=js"
export * from "./AdminPermission.vue?vue&type=script&lang=js"
import style0 from "./AdminPermission.vue?vue&type=style&index=0&id=0810ca58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0810ca58",
  null
  
)

export default component.exports